{
  "Accessibility Menu": "เมนูการช่วยการเข้าถึง",
  "Reset settings": "รีเซ็ตการตั้งค่า",
  "Close": "ปิด",
  "Content Adjustments": "การปรับเนื้อหา",
  "Adjust Font Size": "ปรับขนาดตัวอักษร",
  "Highlight Title": "เน้นหัวเรื่อง",
  "Highlight Links": "เน้นลิงก์",
  "Readable Font": "แบบอักษรที่อ่านง่าย",
  "Color Adjustments": "การปรับสี",
  "Dark Contrast": "ความเปรียบต่างเข้ม",
  "Light Contrast": "ความเปรียบต่างสว่าง",
  "High Contrast": "ความเปรียบต่างสูง",
  "High Saturation": "ความอิ่มตัวของสีสูง",
  "Low Saturation": "ความอิ่มตัวของสีต่ำ",
  "Monochrome": "โมโนโครม",
  "Tools": "เครื่องมือ",
  "Reading Guide": "คู่มือการอ่าน",
  "Stop Animations": "หยุดการเคลื่อนไหว",
  "Big Cursor": "เคอร์เซอร์ขนาดใหญ่",
  "Increase Font Size": "เพิ่มขนาดตัวอักษร",
  "Decrease Font Size": "ลดขนาดตัวอักษร",
  "Letter Spacing": "ระยะห่างระหว่างตัวอักษร",
  "Line Height": "ความสูงของบรรทัด",
  "Font Weight": "น้ำหนักตัวอักษร",
  "Dyslexia Font": "แบบอักษรสำหรับดิสเล็กเซีย",
  "Language": "ภาษา",
  "Open Accessibility Menu": "เปิดเมนูการช่วยการเข้าถึง"
}
